import { useAuthContext } from "src/auth/AuthContext";
import { useParams } from "react-router-dom";
import { fundMoveService } from "@/service/FundMoveService";
import FundMoveForm from "./FundMoveForm";

const FundMoveEdit = () => {
    const { user } = useAuthContext();
    const { id } = useParams();
    return (
        <FundMoveForm
            fundMoveId={parseInt(id ?? "-1")}
            organizationId={user.data.organizationId}
            onSubmit={entry => fundMoveService.update(entry)}
            header="Fondsänderung Bearbeiten"
        />
    );
};

export default FundMoveEdit;
